import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    style: style,
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 12.5C13.5 14.7091 11.7091 16.5 9.5 16.5C7.29086 16.5 5.5 14.7091 5.5 12.5C5.5 10.2909 7.29086 8.5 9.5 8.5C11.7091 8.5 13.5 10.2909 13.5 12.5ZM12 12.5C12 13.8807 10.8807 15 9.5 15C8.11929 15 7 13.8807 7 12.5C7 11.1193 8.11929 10 9.5 10C10.8807 10 12 11.1193 12 12.5Z",
    fill: "black",
    fillOpacity: "0.65"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 18.5V15.5L21.9453 18.4635C22.6099 18.9066 23.5 18.4302 23.5 17.6315V7.36852C23.5 6.56982 22.6099 6.09343 21.9453 6.53647L17.5 9.5V6.5C17.5 5.39543 16.6046 4.5 15.5 4.5H3.5C2.39543 4.5 1.5 5.39543 1.5 6.5V18.5C1.5 19.6046 2.39543 20.5 3.5 20.5H15.5C16.6046 20.5 17.5 19.6046 17.5 18.5ZM15.5 6H3.5C3.22386 6 3 6.22386 3 6.5V18.5C3 18.7761 3.22386 19 3.5 19H15.5C15.7761 19 16 18.7761 16 18.5V6.5C16 6.22386 15.7761 6 15.5 6ZM22 16.6972L17.5 13.6972V11.3028L22 8.30278V16.6972Z",
    fill: "black",
    fillOpacity: "0.65"
  }));
};
export default SVGComponent;